// websocket readyState
// 0 CONNECTING Socket has been created. The connection is not yet open.
// 1 OPEN The connection is open and ready to communicate.
// 2 CLOSING The connection is in the process of closing.
// 3 CLOSED The connection is closed or couldn't be opened.

const getEventCloseCode = (code, reason) => {
  const statusCodes = {
    0: 'Normal Close',
    1000: 'Normal closure, meaning that the purpose for which the connection was established has been fulfilled.',
    1001: 'An endpoint is "going away", such as a server going down or a browser having navigated away from a page.',
    1002: 'An endpoint is terminating the connection due to a protocol error',
    1003: 'An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message).',
    1004: 'Reserved. The specific meaning might be defined in the future.',
    1005: 'No status code was actually present.',
    1006: 'The connection was closed abnormally, e.g., without sending or receiving a Close control frame',
    1007: 'An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [http://tools.ietf.org/html/rfc3629] data within a text message).',
    1008: 'An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other sutible reason, or if there is a need to hide specific details about the policy.',
    1009: 'An endpoint is terminating the connection because it has received a message that is too big for it to process.',
    1010: `An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake. <br /> Specifically, the extensions that are needed are: ${reason}`,
    1011: 'A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request.',
    1015: "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified).",
  };
  return statusCodes[code] || 'Unknown reason';
};
const reconnectionTime = +process.env.REACT_APP_SERVER_WS_RECONNECTIONTIMER || 5000;

const webSocketClient = (webSocketUrl, onOpen, onClose, onSocketEvent) => {
  if (!webSocketUrl) return 'WebSocket Url is Missing';
  let ws = new WebSocket(webSocketUrl);
  let keepaliveTimer = null;
  let reconnectTimer = null;
  const KEEPALIVE_TIMEOUT = 5000;
  const responseDeffers = {};
  let requestId = 1;

  const ON_OPEN = () => {
    clearTimeout(reconnectTimer);
    keepaliveTimer = setInterval(() => ws.send('keepalive'), KEEPALIVE_TIMEOUT);
    onOpen(ws);
  };

  const ON_MESSAGE = ({ data }) => {
    const resolveRequest = (msid, message) => {
      responseDeffers[msid].resolve(message);
      delete responseDeffers[msid];
    };
    const rejectRequest = (msid, message) => {
      responseDeffers[msid].reject(message);
    };

    if (data.indexOf('keepalive_to_client') !== -1) return false;
    if (data.indexOf('keepalive:serv_ws_ok') !== -1) return false;
    if (!data) return false;

    try {
      const json = JSON.parse(data);
      const {
        msid, status, error, eqEvent,
      } = json;
      if (!msid) {
        try {
          const { event } = eqEvent;
          onSocketEvent(event, { ...eqEvent }, ws);
        } catch (e) {
          console.error(e);
        }
        return false;
      }
      if (status === 'ok') {
        return resolveRequest(msid, json);
      }
      return rejectRequest(msid, error);
    } catch (e) {
      return console.error(e);
    }
  };
  const SEND_MESSAGE = (msg) => {
    const reqId = `${msg.command}-${requestId += 1}`;
    const sendData = {
      ...msg,
      msid: reqId,
    };

    return new Promise((resolve, reject) => {
      responseDeffers[reqId] = { resolve, reject };
      if (ws.readyState === ws.OPEN) {
        ws.send(JSON.stringify(sendData));
      } else {
        reject(new Error('Websocket connection is closed'));
      }
    });
  };
  const ON_CLOSE = ({ code, reason, wasClean }) => {
    const status = getEventCloseCode(code, reason);
    clearInterval(keepaliveTimer);
    onClose();
    ws.close();
    if (!wasClean) {
      console.error(status);
      reconnectTimer = setTimeout(() => {
        ws = new WebSocket(webSocketUrl);
        ws.onclose = ON_CLOSE;
        ws.onmessage = ON_MESSAGE;
        ws.sendMessage = SEND_MESSAGE;
        ws.onopen = ON_OPEN;
        console.info(ws, 'Try reconnect to websocket...', ws.readyState);
      }, reconnectionTime);
    }
  };
  ws.onclose = ON_CLOSE;
  ws.onmessage = ON_MESSAGE;
  ws.sendMessage = SEND_MESSAGE;
  ws.onopen = ON_OPEN;
  return ws;
};
export default webSocketClient;
